<template>
    <div class="bottom-opt-bar-wrapper">
        <RoundButton :text="continueBtn" @btnClick="continueClick" v-show="isContinue && isFirstCreate" />
        <div class="save-bar">
            <RoundButton :text="cancelBtn" @btnClick="cancelClick" class="cancel-btn" />
            <RoundButton :text="saveBtnText" @btnClick="saveClick" :class="{ 'save-btn': isActiveSave }" />
        </div>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";

export default {
    name: "BottomOptBar",
    components: {
        RoundButton
    },
    data() {
        return {
            isContinue: false,
            saveBtnText: ""
        };
    },
    computed: {
        cancelBtn() {
            return this.$t("zhiji.common.cancel");
        },
        continueBtn() {
            return this.$t("zhiji.form.addContinue");
        },
        isFirstCreate() {
            return this.getStorePorp("isFirstCreate");
        },
        isActiveSave() {
            return !this.getStorePorp("isActiveSaveBtn");
        },
        tagId() {
            return this.getStorePorp("formInfo").tagId;
        },
        saveBtn() {
            return this.getStorePorp("saveBtnValue");
        }
    },
    watch: {
        saveBtn: {
            handler(newValue) {
                if (newValue === "2") {
                    this.isContinue = true;
                    this.saveBtnText = this.$t("zhiji.common.saved");
                } else {
                    this.saveBtnText = this.$t("zhiji.common.save");
                }
            },
            immediate: true
        }
    },
    methods: {
        saveClick() {
            if (!this.isActiveSave) {
                setTimeout(() => {
                    this.$store.dispatch("zhiji/saveFormEditor");
                    this.$emit("continueClick", {
                        isContinueAdd: false
                    });
                }, 300);
            }
        },
        cancelClick() {
            this.$emit("cancelClick");
        },
        continueClick() {
            this.isContinue = false;
            this.initData();
            this.$emit("continueClick", {
                isContinueAdd: true
            });
        },
        initData() {
            this.$store.commit("zhiji/editFormsClearModule", {
                tagId: this.tagId
            });
            this.$store.dispatch("zhiji/initFormEditor", {});
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.formEdit[propName];
        }
    }
};
</script>

<style lang="scss" scoped>
.bottom-opt-bar-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 8px 16px 24px;
    border-top: 1px solid #d9e4ef;
    background: #f2f7fb;
    .cancel-btn {
        border: solid 1px #d8e4f0;
        color: #41475e;
        background: #fff;
        box-shadow: none;
        width: 112px;
        box-sizing: border-box;
        line-height: 30px;
        &:hover {
            color: #2ec2ff;
            background-color: #fff;
        }
    }

    .save-btn {
        background: #c9c9c9;
        border-color: #c9c9c9;
    }
    .save-bar {
        width: 100%;
        text-align: right;
    }
}
</style>
